import React, { useEffect, useRef, useState } from "react";
import { Grid, Button, Typography, Box } from "@mui/material";
import Layout from "../../layout/Layout";
import {
  config,
  invoiceItemsAPI,
  manageInvoiceAPI,
  manageInvoiceTermsAndConditionsAPI,
  manageStoreMasterAPI,
  termsAndConditionsAPI,
} from "../../config";
import companyLogo from "./../../assets/images/Logo/logo.png";
import kgFurnTechLogo from "./../../assets/images/Logo/Kg_furn_logo.jpg";
import kgConstructionLogo from "./../../assets/images/Logo/kg_const_logo.jpg";
import kgTradeTechLogo from "./../../assets/images/Logo/kg_trade_logo.png";
import axios from "axios";
// import NotFound from "../../../components/NotFount";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useParams, useNavigate } from "react-router-dom";
// import { saveAs } from "file-saver";

import numberToWords from "number-to-words";
import { ToWords } from "to-words";

import moment from "moment";
import "moment/locale/en-in";
import { useReactToPrint } from "react-to-print";
import PurchaseOrderPDF from "./pdf/GeneratePdf";
import DOMPurify from "dompurify";

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      // can be used to override defaults for the selected locale
      name: "Rupee",
      plural: "Rupees",
      symbol: "₹",
      fractionalUnit: {
        name: "Paisa",
        plural: "Paise",
        symbol: "",
      },
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const twoDecimal = (x) => {
  return Number.parseFloat(x).toFixed(2);
};

const handleNumberToWOrdCurrency = (v) => {
  return toWords.convert(roundUpToInteger(v));
};

function roundUpToInteger(value) {
  const roundedValue = Math.ceil(value);
  const formattedValue = roundedValue.toFixed(2);
  return formattedValue;
}

function calculateRoundingDifference(value) {
  const roundedValue = Math.ceil(value);
  const difference = roundedValue - value;
  return difference.toFixed(2);
}

function InvoiceView() {
  const { poid } = useParams();

  const handlePrint = useReactToPrint({
    content: () => ref.current,
    documentTitle: `P.O.pdf`,
    onAfterPrint: () => alert("PDF generated successfully!"),
  });

  const [poDetails, setPODetails] = useState([]);
  const [paymentList, setPaymentList] = useState("");

  const [termsName, setTermsName] = useState("");
  const [terms, setTermsandConditions] = useState("");
  const [termsNames, setTermsNames] = useState([]);
  let tempRefs = useRef(false);

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 4,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = manageInvoiceTermsAndConditionsAPI;

      axios(config)
        .then(function (response) {
          setTermsNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  let tempRef = useRef(false);
  const [storeDetails, setStoreDetails] = useState([]);
  useEffect(() => {
    if (tempRef.current === false) {
      const data = {
        intType: 2,
        intInvoiceId: poid,
        intLimit: 1,
        intOffset: 0,
      };
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = manageInvoiceAPI;
      axios(config)
        .then(function (response) {
          setPODetails(response.data.result[0]);
          if (response.data.result[0].store_name > 0) {
            const data = {
              intType: 4,
              intStoreID: response.data.result[0].store_name,
            };
            config.method = "POST";
            config.data = JSON.stringify(data);
            config.url = manageStoreMasterAPI;
            axios(config)
              .then((response) => {
                setStoreDetails(response.data.result[0]);
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  // need to change in this useeffect
  useEffect(() => {
    if (tempRef.current === false) {
      const data = {
        intIONo: parseInt(poid),
        intType: 2,
        intLimit: 1,
        intOffset: 0,
      };
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = invoiceItemsAPI;

      axios(config)
        .then(function (response) {
          setPaymentList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  const ref = React.createRef();
  const setPOStatus = (status) => {
    const data = {
      intType: 2,
      intStatus: status,
      intInvoiceId: poid,
    };
    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = manageInvoiceAPI;

    axios(config)
      .then(function (response) {})
      .catch(function (error) {
        console.log(error);
      });
    return () => {
      tempRef.current = true;
    };
  };

  

  const twoDecimal = (x) => {
    return Number.parseFloat(x).toFixed(2);
  };

  const splitAddressLine = (address) => {
    const parts = address.split(", ");
    if (parts.length >= 2) {
      return parts[0] + "\n" + parts[1] + "\n" + parts[2];
    }
    return "Plot No 108, Perumal Koil Street, Alapakkam";
  };

  // DOM oruifier for convert HTML to text
  const renderHTML = (htmlString) => {
    return { __html: DOMPurify.sanitize(htmlString) };
  };

  return (
    <Layout>
      <Grid className="login-text-background list_advance">
        <Typography variant="h5" textAlign="center">
          Invoice View
        </Typography>
      </Grid>
      <Grid container spacing={2} className={`bg-white`}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid className="element-to-po" ref={ref}>
            <style>{`
              .tax-invoice-box {
                width: 100%;
                max-width: 800px;
                margin: 0 auto;
                border: 1px solid #000;
                font-family: Arial, sans-serif;
                font-size: 10px;
                color: #000;
                background-color: #fff;
              }
              .tax-invoice-box table {
                width: 100%;
                border-collapse: collapse;
              }
              .tax-invoice-box th, .tax-invoice-box td {
                border: 1px solid #000;
                padding: 4px;
                vertical-align: top;
                font-size: 10px;
                line-height: 1.2;
              }
              .tax-invoice-box .no-border {
                border: none !important;
              }
              .tax-invoice-box .text-center {
                text-align: center;
              }
              .tax-invoice-box .text-right {
                text-align: right;
              }
              .tax-invoice-box .text-bold {
                font-weight: bold;
              }
              .tax-invoice-box .title-header {
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                padding: 6px;
                border-bottom: 1px solid #000;
                text-transform: uppercase;
              }
              .tax-invoice-box .sub-table td {
                border: none;
                padding: 2px 4px;
              }
              .tax-invoice-box .grid-table th {
                background-color: #f5f5f5;
                font-weight: bold;
                text-align: center;
              }
              .tax-invoice-box .grid-table td {
                height: 120px; /* fixed height for items section to keep single page */
              }
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .tax-invoice-box {
                  border: 1px solid #000 !important;
                  width: 100%;
                  max-width: 100%;
                }
                .element-to-po {
                  padding: 0 !important;
                  margin: 0 !important;
                }
                @page {
                  size: A4;
                  margin: 10mm;
                }
              }
            `}</style>
            <div className="tax-invoice-box">
              <div className="title-header">Tax Invoice</div>
              
              {/* Header Info Grid */}
              <table>
                <tbody>
                  <tr>
                    {/* Seller Details */}
                    <td style={{ width: "50%", borderLeft: "none", borderTop: "none" }}>
                      <div className="text-bold" style={{ fontSize: "11px" }}>{poDetails.company_name}</div>
                      <div>{poDetails.address}</div>
                      <div>{poDetails.city} - {poDetails.pincode}</div>
                      <div>Mobile: {poDetails.primary_contact} {poDetails.secondary_contact ? `/ ${poDetails.secondary_contact}` : ""}</div>
                      <div>Email: {poDetails.email_id}</div>
                      <div className="text-bold" style={{ marginTop: "4px" }}>GSTIN/UIN: {poDetails.gst_no}</div>
                      <div>State Name: {poDetails.state}, Code: {poDetails.state ? (poDetails.state.toLowerCase().includes("tamilnadu") ? "33" : "33") : "33"}</div>
                    </td>
                    
                    {/* Invoice & Order Details */}
                    <td style={{ width: "50%", borderRight: "none", borderTop: "none", padding: 0 }}>
                      <table className="sub-table" style={{ width: "100%" }}>
                        <tbody>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Invoice No.</div>
                              <div className="text-bold">{poDetails.invoice_no}</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Dated</div>
                              <div className="text-bold">{poDetails.createdAt ? moment(poDetails.createdAt).format("DD-MMM-YY") : ""}</div>
                            </td>
                          </tr>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Delivery Note</div>
                              <div className="text-bold">-</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Mode/Terms of Payment</div>
                              <div className="text-bold">{poDetails.terms_of_payments || "N/A"}</div>
                            </td>
                          </tr>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Reference No. & Date</div>
                              <div className="text-bold">-</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Other References</div>
                              <div className="text-bold">-</div>
                            </td>
                          </tr>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Buyer's Order No.</div>
                              <div className="text-bold">{poDetails.po_ref_no || "N/A"}</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Dated</div>
                              <div className="text-bold">{poDetails.po_date ? moment(poDetails.po_date).format("DD-MMM-YY") : "N/A"}</div>
                            </td>
                          </tr>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Dispatch Doc No.</div>
                              <div className="text-bold">-</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Delivery Note Date</div>
                              <div className="text-bold">-</div>
                            </td>
                          </tr>
                          <tr style={{ borderBottom: "1px solid #000" }}>
                            <td style={{ width: "50%", borderRight: "1px solid #000" }}>
                              <div>Dispatched through</div>
                              <div className="text-bold">-</div>
                            </td>
                            <td style={{ width: "50%" }}>
                              <div>Destination</div>
                              <div className="text-bold">-</div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <div>Terms of Delivery</div>
                              <div style={{ minHeight: "20px" }}>-</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  
                  {/* Consignee & Buyer */}
                  <tr>
                    {/* Consignee */}
                    <td style={{ width: "50%", borderLeft: "none" }}>
                      <div className="text-bold" style={{ textDecoration: "underline" }}>Consignee (Ship to)</div>
                      {Object.keys(storeDetails).length > 0 ? (
                        <>
                          <div className="text-bold">{poDetails.client_name}</div>
                          <div>{storeDetails.store_name}</div>
                          <div>{storeDetails.address}, {storeDetails.city}</div>
                          <div>{storeDetails.state} - {storeDetails.pin_code}</div>
                          <div className="text-bold">GSTIN/UIN: {poDetails.client_gst}</div>
                          <div>State Name: {storeDetails.state}, Code: {storeDetails.state ? (storeDetails.state.toLowerCase().includes("tamilnadu") ? "33" : "33") : "33"}</div>
                        </>
                      ) : (
                        <div style={{ color: "#888", fontStyle: "italic" }}>Same as Buyer</div>
                      )}
                    </td>
                    
                    {/* Buyer */}
                    <td style={{ width: "50%", borderRight: "none" }}>
                      <div className="text-bold" style={{ textDecoration: "underline" }}>Buyer (Bill to)</div>
                      <div className="text-bold">{poDetails.client_name}</div>
                      <div>{poDetails.client_address}</div>
                      <div>{poDetails.client_city} - {poDetails.client_pincode}</div>
                      <div>{poDetails.client_state}</div>
                      <div className="text-bold">GSTIN/UIN: {poDetails.client_gst}</div>
                      <div>State Name: {poDetails.client_state}, Code: {poDetails.client_state ? (poDetails.client_state.toLowerCase().includes("tamilnadu") ? "33" : "33") : "33"}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              {/* Line Items Table */}
              <table style={{ borderTop: "none" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%", borderLeft: "none", borderTop: "none" }} className="text-center text-bold">SI No.</th>
                    <th style={{ width: "50%", borderTop: "none" }} className="text-center text-bold">Particulars</th>
                    <th style={{ width: "10%", borderTop: "none" }} className="text-center text-bold">HSN/SAC</th>
                    <th style={{ width: "10%", borderTop: "none" }} className="text-center text-bold">Quantity</th>
                    <th style={{ width: "10%", borderTop: "none" }} className="text-center text-bold">Rate</th>
                    <th style={{ width: "5%", borderTop: "none" }} className="text-center text-bold">per</th>
                    <th style={{ width: "10%", borderRight: "none", borderTop: "none" }} className="text-center text-bold">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentList.length > 0 ? (
                    paymentList.map((row, index) => {
                      const hasTax = parseFloat(row.cgst || 0) > 0 || parseFloat(row.sgst || 0) > 0 || parseFloat(row.igst || 0) > 0;
                      return (
                        <React.Fragment key={index}>
                          {/* Main Item Row */}
                          <tr style={{ borderBottom: hasTax ? "none" : "1px solid #000" }}>
                            <td className="text-center" style={{ borderLeft: "none", borderBottom: "none" }}>{index + 1}</td>
                            <td className="text-bold" style={{ borderBottom: "none" }}>
                              {row.item_name}
                              {row.item_description && <div style={{ fontWeight: "normal", fontSize: "9px", color: "#555" }}>{row.item_description}</div>}
                            </td>
                            <td className="text-center" style={{ borderBottom: "none" }}>{row.hsn_code || "995419"}</td>
                            <td className="text-right" style={{ borderBottom: "none" }}>{twoDecimal(row.quantity)}</td>
                            <td className="text-right" style={{ borderBottom: "none" }}>{twoDecimal(row.rate)}</td>
                            <td className="text-center" style={{ borderBottom: "none" }}>{row.unit_name || "nos"}</td>
                            <td className="text-right text-bold" style={{ borderRight: "none", borderBottom: "none" }}>{twoDecimal(row.total_amount_without_gst)}</td>
                          </tr>
                          
                          {/* Tax Rows nested directly under the item row */}
                          {parseFloat(row.cgst || 0) > 0 && (
                            <tr style={{ borderBottom: "none" }}>
                              <td style={{ borderLeft: "none", borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ paddingLeft: "20px", borderTop: "none", borderBottom: "none" }}>CGST</td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td className="text-right" style={{ borderRight: "none", borderTop: "none", borderBottom: "none" }}>{twoDecimal(row.cgst)}</td>
                            </tr>
                          )}
                          {parseFloat(row.sgst || 0) > 0 && (
                            <tr style={{ borderBottom: "none" }}>
                              <td style={{ borderLeft: "none", borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ paddingLeft: "20px", borderTop: "none", borderBottom: "none" }}>SGST</td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td className="text-right" style={{ borderRight: "none", borderTop: "none", borderBottom: "none" }}>{twoDecimal(row.sgst)}</td>
                            </tr>
                          )}
                          {parseFloat(row.igst || 0) > 0 && (
                            <tr style={{ borderBottom: "none" }}>
                              <td style={{ borderLeft: "none", borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ paddingLeft: "20px", borderTop: "none", borderBottom: "none" }}>IGST</td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td style={{ borderTop: "none", borderBottom: "none" }}></td>
                              <td className="text-right" style={{ borderRight: "none", borderTop: "none", borderBottom: "none" }}>{twoDecimal(row.igst)}</td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : null}
                  
                  {/* Empty Spacer Row to ensure layout structure */}
                  <tr>
                    <td style={{ borderLeft: "none", borderBottom: "none", height: "40px" }}></td>
                    <td style={{ borderBottom: "none" }}></td>
                    <td style={{ borderBottom: "none" }}></td>
                    <td style={{ borderBottom: "none" }}></td>
                    <td style={{ borderBottom: "none" }}></td>
                    <td style={{ borderBottom: "none" }}></td>
                    <td style={{ borderRight: "none", borderBottom: "none" }}></td>
                  </tr>

                  {/* Total Row */}
                  <tr style={{ borderTop: "1px solid #000" }}>
                    <td style={{ borderLeft: "none" }}></td>
                    <td className="text-bold text-right" colSpan={5}>Total</td>
                    <td className="text-right text-bold" style={{ borderRight: "none" }}>₹ {twoDecimal(poDetails.total_with_gst)}</td>
                  </tr>
                </tbody>
              </table>

              {/* Amount Chargeable in words */}
              <div style={{ borderBottom: "1px solid #000", padding: "6px" }}>
                <div>Amount Chargeable (in words):</div>
                <div className="text-bold" style={{ fontSize: "11px", marginTop: "2px" }}>
                  {poDetails && poDetails.total_with_gst > 0 ? handleNumberToWOrdCurrency(poDetails.total_with_gst) : ""}
                </div>
              </div>

              {/* HSN/SAC Tax Summary Table */}
              <table style={{ borderBottom: "1px solid #000" }}>
                <thead>
                  <tr>
                    <th style={{ width: "20%", borderLeft: "none", borderTop: "none" }} className="text-center text-bold" rowspan="2">HSN/SAC</th>
                    <th style={{ width: "20%", borderTop: "none" }} className="text-center text-bold" rowspan="2">Taxable Value</th>
                    <th style={{ width: "20%", borderTop: "none" }} className="text-center text-bold" colspan="2">CGST</th>
                    <th style={{ width: "20%", borderTop: "none" }} className="text-center text-bold" colspan="2">SGST/UTGST</th>
                    <th style={{ width: "20%", borderRight: "none", borderTop: "none" }} className="text-center text-bold" rowspan="2">Total Tax Amount</th>
                  </tr>
                  <tr>
                    <th style={{ borderTop: "none" }} className="text-center text-bold">Rate</th>
                    <th style={{ borderTop: "none" }} className="text-center text-bold">Amount</th>
                    <th style={{ borderTop: "none" }} className="text-center text-bold">Rate</th>
                    <th style={{ borderTop: "none" }} className="text-center text-bold">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentList.length > 0 ? (
                    paymentList.map((row, index) => {
                      const gstRate = parseFloat(row.gst || 0);
                      const halfRate = gstRate / 2;
                      const cgstAmount = parseFloat(row.cgst || 0);
                      const sgstAmount = parseFloat(row.sgst || 0);
                      const totalTax = cgstAmount + sgstAmount + parseFloat(row.igst || 0);
                      return (
                        <tr key={index}>
                          <td className="text-center" style={{ borderLeft: "none" }}>{row.hsn_code || "995419"}</td>
                          <td className="text-right">{twoDecimal(row.total_amount_without_gst)}</td>
                          <td className="text-center">{halfRate}%</td>
                          <td className="text-right">{twoDecimal(cgstAmount)}</td>
                          <td className="text-center">{halfRate}%</td>
                          <td className="text-right">{twoDecimal(sgstAmount)}</td>
                          <td className="text-right text-bold" style={{ borderRight: "none" }}>{twoDecimal(totalTax)}</td>
                        </tr>
                      );
                    })
                  ) : null}
                  <tr style={{ borderTop: "1px solid #000" }}>
                    <td className="text-center text-bold" style={{ borderLeft: "none" }}>Total</td>
                    <td className="text-right text-bold">{twoDecimal(poDetails.total_without_gst)}</td>
                    <td></td>
                    <td className="text-right text-bold">{twoDecimal(poDetails.total_cgst)}</td>
                    <td></td>
                    <td className="text-right text-bold">{twoDecimal(poDetails.total_sgst)}</td>
                    <td className="text-right text-bold" style={{ borderRight: "none" }}>{twoDecimal(parseFloat(poDetails.total_cgst || 0) + parseFloat(poDetails.total_sgst || 0) + parseFloat(poDetails.total_igst || 0))}</td>
                  </tr>
                </tbody>
              </table>

              {/* Tax Amount in Words & Bank Details Grid */}
              <table style={{ borderBottom: "none" }}>
                <tbody>
                  <tr>
                    {/* Left: Tax words, Bank details, Terms */}
                    <td style={{ width: "60%", borderLeft: "none", borderTop: "none", borderBottom: "none" }}>
                      <div>Tax Amount (in words): <span className="text-bold">{poDetails ? handleNumberToWOrdCurrency(parseFloat(poDetails.total_cgst || 0) + parseFloat(poDetails.total_sgst || 0) + parseFloat(poDetails.total_igst || 0)) : ""}</span></div>
                      
                      <div className="text-bold" style={{ marginTop: "10px", textDecoration: "underline" }}>Company's Bank Details:</div>
                      <table className="sub-table" style={{ width: "100%", marginTop: "4px" }}>
                        <tbody>
                          <tr>
                            <td className="text-bold" style={{ width: "30%" }}>A/c Holder's Name:</td>
                            <td>{poDetails.account_name}</td>
                          </tr>
                          <tr>
                            <td className="text-bold">Bank Name:</td>
                            <td>{poDetails.bank_name}</td>
                          </tr>
                          <tr>
                            <td className="text-bold">A/c No:</td>
                            <td className="text-bold">{poDetails.account_number}</td>
                          </tr>
                          <tr>
                            <td className="text-bold">Branch & IFS Code:</td>
                            <td>{poDetails.branch} & {poDetails.ifsc_code}</td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ marginTop: "10px" }}>
                        <span className="text-bold">Remarks/Terms:</span>
                        <div dangerouslySetInnerHTML={renderHTML(poDetails.invoice_terms_description)} />
                      </div>
                    </td>
                    
                    {/* Right: Signatures */}
                    <td style={{ width: "40%", borderRight: "none", borderTop: "none", borderBottom: "none", padding: 0 }}>
                      <table style={{ width: "100%", height: "100%" }}>
                        <tbody>
                          <tr>
                            <td className="text-center" style={{ height: "60px", borderTop: "none", borderLeft: "none", borderRight: "none" }}>
                              <div>Customer's Seal and Signature</div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-center" style={{ height: "70px", borderBottom: "none", borderLeft: "none", borderRight: "none" }}>
                              <div>for <span className="text-bold">{poDetails.company_name}</span></div>
                              <div style={{ height: "40px" }}></div>
                              <div className="text-bold">Authorised Signatory</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* Computer Generated Caption */}
              <div className="text-center" style={{ borderTop: "1px solid #000", padding: "4px", fontSize: "9px" }}>
                This is a Computer Generated Invoice
              </div>
            </div>
          </Grid>

          <div className="empty-space-20"></div>
          <div style={{ display: "flex", justifyContent: "center" }}>
           
          </div>
        </Grid>

        <Grid item xs={11}>
          <Box display={`flex`} justifyContent={`flex-end`} mr={2}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<PictureAsPdfIcon />}
              onClick={handlePrint}
              sx={{
                backgroundColor: "#2196f3",
                fontWeight: "bold",
                transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  backgroundColor: "#FFF",
                  color: "#2196f3",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Generate PDF
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default InvoiceView;
